import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type StaffFailureAlertRecipientsResponse = {
  staffFailureAlertRecipients: string[];
};

export const useGetStaffFailureAlertRecipientsQuery = () => {
  const { authApi } = useAuth();

  return useQuery({
    queryKey: ["staff-failure-alert-recipients"],
    queryFn: async () => {
      const { data } = await authApi.get<StaffFailureAlertRecipientsResponse>(
        "/staff/staff-failure-alert-recipients"
      );
      return data.staffFailureAlertRecipients;
    },
  });
};
